<template>
  <div class="d-flex justify-content-center main-links">
    <div
      class="header-container d-flex flex-column py-3 flex-shrink-0"
      :class="notMobile ? 'px-3' : 'px-1'"
    >
      <div
        v-if="!showSubMenu"
        class="d-flex align-items-center justify-content-center mb-0"
        @click="emitSubMenuShow"
      >
        <img
          :src="require('@/assets/images/icons/bread_crumb_double.svg')"
          :class="[{ 'opacity-80 -translate-scale-1': !isLangRtl }, 'cursor-pointer']"
          alt="Sales"
          width="24"
          height="24"
        />
      </div>
      <div
        class="d-flex align-items-center justify-content-center mt-4 mb-2 text-white text-decoration-none"
      >
        <img
          v-if="$store.getters['enums/operator'] === 'eJ'"
          src="@/assets/logo/sekaya-logo.png"
          alt="logo"
          class="nav-sss-logo pb-2"
        />
      </div>
      <div class="mb-5" style="overflow-y: auto">
        <ul class="nav nav-pills flex-column mb-auto">
          <li
            class="nav-item my-2"
            v-if="!$store.getters['enums/is_not_permitted']('dashboardTab')"
          >
            <router-link
              id="sidebar-link-dashboard"
              to="/dashboard/map"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'dashboard',
                },
              ]"
              aria-current="page"
              v-b-tooltip.hover="{
                title: $t('dashboard'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'dashboard'
                    ? require('@/assets/images/icons/dashboard-dark.svg')
                    : require('@/assets/images/icons/dashboard.svg')
                "
                alt="dashboard"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li
            class="nav-item my-2"
            v-if="
              !$store.getters['enums/is_not_permitted']('clientTab') ||
              !$store.getters['enums/is_not_permitted']('listBlanketOrder') ||
              !$store.getters['enums/is_not_permitted']('operationsReservationTab')
            "
          >
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('operationsReservationTab')
                  ? 'sidebar-link-sales'
                  : !$store.getters['enums/is_not_permitted']('clientTab')
                  ? 'sidebar-link-clients'
                  : !$store.getters['enums/is_not_permitted']('listBlanketOrder')
                  ? 'sidebar-link-blanket-orders'
                  : ''
              "
              :to="
                !$store.getters['enums/is_not_permitted']('operationsReservationTab')
                  ? '/operations/list'
                  : !$store.getters['enums/is_not_permitted']('clientTab')
                  ? '/clients'
                  : !$store.getters['enums/is_not_permitted']('listBlanketOrder')
                  ? '/blanket-orders'
                  : ''
              "
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'clients' ||
                    $route.name == 'operations' ||
                    $route.name == 'blanket-orders',
                },
              ]"
              aria-current="page"
              v-b-tooltip.hover="{
                title: $t('sales'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'clients' ||
                  $route.name == 'operations' ||
                  $route.name == 'blanket-orders'
                    ? require('@/assets/images/icons/sales-icon-dark.svg')
                    : require('@/assets/images/icons/sales-icon-light.svg')
                "
                alt="Sales"
                width="24"
                height="24"
              />
            </router-link>
          </li>
          <li
            class="nav-item my-2"
            v-if="
              !$store.getters['enums/is_not_permitted']('operationsContractedJourneyTab') ||
              !$store.getters['enums/is_not_permitted']('operationsCheckAvailabilityTab') ||
              !$store.getters['enums/is_not_permitted']('reportedIssues') ||
              !$store.getters['enums/is_not_permitted']('transactionLogTab') ||
              !$store.getters['enums/is_not_permitted']('viewDriverAllowance')
            "
          >
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('operationsContractedJourneyTab')
                  ? 'sidebar-link-manage-trips'
                  : !$store.getters['enums/is_not_permitted']('operationsCheckAvailabilityTab')
                  ? 'sidebar-link-check-availability'
                  : !$store.getters['enums/is_not_permitted']('reportedIssues')
                  ? 'sidebar-link-reported-issues'
                  : !$store.getters['enums/is_not_permitted']('transactionLogTab')
                  ? 'sidebar-link-transaction-log'
                  : !$store.getters['enums/is_not_permitted']('viewDriverAllowance')
                  ? 'sidebar-link-driver-allowance'
                  : ''
              "
              :to="
                !$store.getters['enums/is_not_permitted']('operationsContractedJourneyTab')
                  ? '/manage-trips'
                  : !$store.getters['enums/is_not_permitted']('operationsCheckAvailabilityTab')
                  ? '/check-availability'
                  : !$store.getters['enums/is_not_permitted']('reportedIssues')
                  ? '/reported-issues'
                  : !$store.getters['enums/is_not_permitted']('transactionLogTab')
                  ? '/transaction-log'
                  : !$store.getters['enums/is_not_permitted']('viewDriverAllowance')
                  ? '/driver-allowance'
                  : ''
              "
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'departure-arrival' ||
                    $route.name == 'vehicle-operations' ||
                    $route.name == 'manage-trips' ||
                    $route.name == 'transaction-log' ||
                    $route.name == 'external-log' ||
                    $route.name == 'driver-allowance' ||
                    $route.name == 'check-availability' ||
                    $route.name == 'long-terms' ||
                    $route.name == 'reported-issues',
                },
              ]"
              aria-current="page"
              v-b-tooltip.hover="{
                title: $t('operations'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'departure-arrival' ||
                  $route.name == 'vehicle-operations' ||
                  $route.name == 'manage-trips' ||
                  $route.name == 'transaction-log' ||
                  $route.name == 'external-log' ||
                  $route.name == 'driver-allowance' ||
                  $route.name == 'check-availability' ||
                  $route.name == 'long-terms' ||
                  $route.name == 'reported-issues'
                    ? require('@/assets/images/icons/setting-icon-dark.svg')
                    : require('@/assets/images/icons/setting-icon-light.svg')
                "
                alt="Operations"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li
            class="nav-item my-2"
            v-if="
              !$store.getters['enums/is_not_permitted']('driverTab') ||
              !$store.getters['enums/is_not_permitted']('vehicleTab')
            "
          >
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('driverTab')
                  ? 'sidebar-link-drivers'
                  : !$store.getters['enums/is_not_permitted']('vehicleTab')
                  ? 'sidebar-link-vehicles'
                  : ''
              "
              :to="
                !$store.getters['enums/is_not_permitted']('driverTab')
                  ? '/drivers'
                  : !$store.getters['enums/is_not_permitted']('vehicleTab')
                  ? '/vehicles'
                  : ''
              "
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'drivers' || $route.name == 'vehicles',
                },
              ]"
              aria-current="page"
              v-b-tooltip.hover="{
                title: $t('resources'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'drivers' || $route.name == 'vehicles'
                    ? require('@/assets/images/icons/client-dark.svg')
                    : require('@/assets/images/icons/client.svg')
                "
                alt="Operations"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li class="nav-item my-2" v-if="!$store.getters['enums/is_not_permitted']('contractTab')">
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('contractTab')
                  ? 'sidebar-link-contracts'
                  : ''
              "
              :to="!$store.getters['enums/is_not_permitted']('contractTab') ? '/contracts' : ''"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'contracts',
                },
              ]"
              aria-current="page"
              v-b-tooltip.hover="{
                title: $t('contracts'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'contracts'
                    ? require('@/assets/images/icons/contract-icon-dark.svg')
                    : require('@/assets/images/icons/contract-icon.svg')
                "
                alt="contracts"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li
            v-if="
              !$store.getters['enums/is_not_permitted']('viewTemporaryRequest') ||
              !$store.getters['enums/is_not_permitted']('viewTemporaryResourcesRequest') ||
              !$store.getters['enums/is_not_permitted']('viewReservationRequest') ||
              !$store.getters['enums/is_not_permitted']('replaceRequestTab') ||
              !$store.getters['enums/is_not_permitted']('operationsApprovalRequestTab') ||
              !$store.getters['enums/is_not_permitted']('timeOffRequest') ||
              !$store.getters['enums/is_not_permitted']('viewReservationRequest') ||
              !$store.getters['enums/is_not_permitted']('viewDriverAllowance') ||
              !$store.getters['enums/is_not_permitted']('manageAllTasks') ||
              !$store.getters['enums/is_not_permitted']('viewMyTasks')
            "
            class="my-2"
          >
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('viewTemporaryRequest')
                  ? 'sidebar-link-resource-requests'
                  : !$store.getters['enums/is_not_permitted']('viewTemporaryResourcesRequest') ||
                    !$store.getters['enums/is_not_permitted']('viewReservationRequest')
                  ? 'sidebar-link-my-requests'
                  : !$store.getters['enums/is_not_permitted']('replaceRequestTab')
                  ? 'sidebar-link-replace-requests-list'
                  : !$store.getters['enums/is_not_permitted']('operationsApprovalRequestTab')
                  ? 'sidebar-link-approval-requests'
                  : !$store.getters['enums/is_not_permitted']('timeOffRequest')
                  ? 'sidebar-link-time-off-requests'
                  : !$store.getters['enums/is_not_permitted']('viewReservationRequest')
                  ? 'sidebar-link-reservations-requests'
                  : !$store.getters['enums/is_not_permitted']('viewDriverAllowance')
                  ? 'sidebar-link-allowance-requests'
                  : !$store.getters['enums/is_not_permitted']('manageAllTasks') ||
                    !$store.getters['enums/is_not_permitted']('viewMyTasks')
                  ? 'sidebar-link-workflow-requests'
                  : ''
              "
              :to="
                !$store.getters['enums/is_not_permitted']('viewTemporaryRequest')
                  ? '/resource-requests'
                  : !$store.getters['enums/is_not_permitted']('viewTemporaryResourcesRequest') ||
                    !$store.getters['enums/is_not_permitted']('viewReservationRequest')
                  ? '/my-requests'
                  : !$store.getters['enums/is_not_permitted']('replaceRequestTab')
                  ? '/replace-requests-list'
                  : !$store.getters['enums/is_not_permitted']('operationsApprovalRequestTab')
                  ? '/approval-requests'
                  : !$store.getters['enums/is_not_permitted']('timeOffRequest')
                  ? '/time-off-requests'
                  : !$store.getters['enums/is_not_permitted']('viewReservationRequest')
                  ? '/reservations-requests'
                  : !$store.getters['enums/is_not_permitted']('viewDriverAllowance')
                  ? '/allowance-requests'
                  : !$store.getters['enums/is_not_permitted']('manageAllTasks') ||
                    !$store.getters['enums/is_not_permitted']('viewMyTasks')
                  ? '/workflow-requests'
                  : ''
              "
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'resource-requests' ||
                    $route.name == 'my-requests' ||
                    $route.name == 'replace-requests-list' ||
                    $route.name == 'approval-requests' ||
                    $route.name == 'time-off-requests' ||
                    $route.name == 'reservations-requests' ||
                    $route.name == 'allowance-requests' ||
                    $route.name == 'workflow-requests',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('requests'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'resource-requests' ||
                  $route.name == 'my-requests' ||
                  $route.name == 'replace-requests-list' ||
                  $route.name == 'approval-requests' ||
                  $route.name == 'time-off-requests' ||
                  $route.name == 'reservations-requests' ||
                  $route.name == 'allowance-requests' ||
                  $route.name == 'workflow-requests'
                    ? require('@/assets/images/icons/requests-icon-dark.svg')
                    : require('@/assets/images/icons/requests-icon.svg')
                "
                alt="requests-icon"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li class="my-2" v-if="!$store.getters['enums/is_not_permitted']('supportChatTab')">
            <router-link
              id="sidebar-link-messaging-center"
              to="/messaging-center"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'messaging-center',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('messaging-center'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'messaging-center'
                    ? require('@/assets/images/icons/messaging-center-icon.svg')
                    : require('@/assets/images/icons/messaging-center-icon-light.svg')
                "
                alt="messaging-center"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li
            class="my-2"
            v-if="
              !$store.getters['enums/is_not_permitted']('systemManagementTab') &&
              (!$store.getters['enums/is_not_permitted']('systemCategoryTab') ||
                !$store.getters['enums/is_not_permitted']('systemRegionManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemDriverManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemSlotsManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemSalesOrderManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemVehiclesManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemCompaniesManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemUserAndRolesManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemProductsManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemTraningTypeManagementTab') ||
                !$store.getters['enums/is_not_permitted']('systemTgaManagementTab'))
            "
          >
            <router-link
              id="sidebar-link-system-management"
              to="/system-management"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'system-management',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('system-management'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'SystemManagementView'
                    ? require('@/assets/images/icons/system-management-dark.svg')
                    : require('@/assets/images/icons/management-system.svg')
                "
                alt="System Management"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <!-- ── Finances nav icon ── -->
          <!-- Added: financeCertificateOfCompletion to v-if, :id chain, :to chain, and active :class -->
          <li
            class="my-2"
            v-if="
              !$store.getters['enums/is_not_permitted']('receiptVoucherTab') ||
              !$store.getters['enums/is_not_permitted']('financeAccountsTab') ||
              !$store.getters['enums/is_not_permitted']('financeProformaInvoiceTab') ||
              !$store.getters['enums/is_not_permitted']('financeCertificateOfCompletion') ||
              $store.getters['enums/is_not_permitted']('financeJVTab') ||
              !$store.getters['enums/is_not_permitted']('viewTransaction') ||
              !$store.getters['enums/is_not_permitted']('viewPaymentVoucher') ||
              !$store.getters['enums/is_not_permitted']('taxTypeTab') ||
              !$store.getters['enums/is_not_permitted']('viewFinancialClaim') ||
              !$store.getters['enums/is_not_permitted']('masterAccountsTab')
            "
          >
            <router-link
              :id="
                !$store.getters['enums/is_not_permitted']('receiptVoucherTab')
                  ? 'sidebar-link-finances'
                  : !$store.getters['enums/is_not_permitted']('financeAccountsTab')
                  ? 'sidebar-link-account-listing'
                  : !$store.getters['enums/is_not_permitted']('financeProformaInvoiceTab')
                  ? 'sidebar-link-proforma-invoice-listing'
                  : $store.getters['enums/is_not_permitted']('financeCertificateOfCompletion')
                  ? 'sidebar-link-certificates_of_completion'
                  : $store.getters['enums/is_not_permitted']('financeJVTab')
                  ? 'sidebar-link-jv-listing'
                  : !$store.getters['enums/is_not_permitted']('viewTransaction')
                  ? 'sidebar-link-post-transactions-listing'
                  : !$store.getters['enums/is_not_permitted']('viewPaymentVoucher')
                  ? 'sidebar-link-payment-voucher-listing'
                  : !$store.getters['enums/is_not_permitted']('taxTypeTab')
                  ? 'sidebar-link-tax-types-listing'
                  : !$store.getters['enums/is_not_permitted']('masterAccountsTab')
                  ? 'sidebar-link-master-accounts'
                  : !$store.getters['enums/is_not_permitted']('viewFinancialClaim')
                  ? 'sidebar-link-financial-claim-listing'
                  : ''
              "
              :to="
                !$store.getters['enums/is_not_permitted']('receiptVoucherTab')
                  ? '/finances'
                  : !$store.getters['enums/is_not_permitted']('financeAccountsTab')
                  ? '/account-listing'
                  : !$store.getters['enums/is_not_permitted']('financeProformaInvoiceTab')
                  ? '/proforma-invoice-listing'
                  : $store.getters['enums/is_not_permitted']('financeCertificateOfCompletion')
                  ? '/certificates_of_completion'
                  : $store.getters['enums/is_not_permitted']('financeJVTab')
                  ? '/jv-listing'
                  : !$store.getters['enums/is_not_permitted']('viewTransaction')
                  ? '/post-transactions'
                  : !$store.getters['enums/is_not_permitted']('viewPaymentVoucher')
                  ? '/payment-voucher'
                  : !$store.getters['enums/is_not_permitted']('taxTypeTab')
                  ? '/tax-types'
                  : !$store.getters['enums/is_not_permitted']('masterAccountsTab')
                  ? '/master-accounts'
                  : !$store.getters['enums/is_not_permitted']('viewFinancialClaim')
                  ? '/financial-claim'
                  : ''
              "
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'finances' ||
                    $route.name == 'account-listing' ||
                    $route.name == 'proforma-invoice-listing' ||
                    $route.name == 'certificates_of_completion' ||
                    $route.name == 'jv-listing' ||
                    $route.name == 'tax-types' ||
                    $route.name == 'post-transactions' ||
                    $route.name == 'payment-voucher' ||
                    $route.name == 'statement' ||
                    $route.name == 'financial-claim' ||
                    $route.name == 'master-accounts',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('finances'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'finances' ||
                  $route.name == 'account-listing' ||
                  $route.name == 'proforma-invoice-listing' ||
                  $route.name == 'certificates_of_completion' ||
                  $route.name == 'jv-listing' ||
                  $route.name == 'tax-types' ||
                  $route.name == 'post-transactions' ||
                  $route.name == 'payment-voucher' ||
                  $route.name == 'statement' ||
                  $route.name == 'financial-claim' ||
                  $route.name == 'master-accounts'
                    ? require('@/assets/images/icons/finance-icon-dark.svg')
                    : require('@/assets/images/icons/finance-icon.svg')
                "
                alt="finance-icon"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li class="my-2" v-if="!$store.getters['enums/is_not_permitted']('supplierTab')">
            <router-link
              id="sidebar-link-suppliers"
              to="/suppliers"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'suppliers',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('partners'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'suppliers'
                    ? require('@/assets/images/icons/ap-ar-dark.svg')
                    : require('@/assets/images/icons/ap-ar.svg')
                "
                alt="ap-ar-icon"
                width="24"
                height="24"
              />
            </router-link>
          </li>

          <li v-if="!$store.getters['enums/is_not_permitted']('companyProfileTab')" class="my-2">
            <router-link
              id="sidebar-link-company-profile"
              to="/company-profile"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'CompanyProfile',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('company-profile'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'CompanyProfile'
                    ? require('@/assets/images/icons/company-profile-dark.svg')
                    : require('@/assets/images/icons/company-profile.svg')
                "
                alt="System Management"
                width="24"
                height="24"
              />
            </router-link>
          </li>
          <li class="my-2">
            <router-link
              id="sidebar-link-my-profile"
              to="/my-profile"
              :class="[
                'nav-link ',
                {
                  'router-link-exact-active router-link-active': $route.name == 'my-profile',
                },
              ]"
              v-b-tooltip.hover="{
                title: $t('my-profile'),
                placement: isLangRtl ? 'left' : 'right',
              }"
            >
              <img
                :src="
                  $route.name == 'my-profile'
                    ? require('@/assets/images/icons/my-profile-dark.svg')
                    : require('@/assets/images/icons/my-profile.svg')
                "
                alt="my-profile"
                width="24"
                height="24"
              />
            </router-link>
          </li>
        </ul>
      </div>
      <div style="position: absolute; bottom: 1rem">
        <ul class="nav nav-pills flex-column mb-auto">
          <li class="mt-3">
            <div class="nav-link cursor-pointer" id="sidebar-link-logout" @click="logout">
              <img
                :src="require('@/assets/images/icons/LogOut.svg')"
                alt="LogOut"
                width="24"
                height="24"
              />
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="
        (isCollapsed1 ||
          isCollapsed2 ||
          isCollapsed3 ||
          isCollapsed4 ||
          isCollapsed5 ||
          isCollapsed6 ||
          isCollapsed7 ||
          isCollapsed8) &&
        showSubMenu
      "
      class="header-container d-flex flex-column py-3 flex-shrink-0 sub-links"
    >
      <div class="ms-auto position-absolute toggle-sub-menu" @click="toggleSubMenu">
        <img
          :src="require('@/assets/images/icons/bread_crumb_double.svg')"
          :class="{
            'cursor-pointer me-3 opacity-80': true,
            '-translate-scale-1': isLangRtl,
          }"
          alt="Sales"
          width="24"
          height="24"
        />
      </div>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed1"
          :class="{ collapsed: isCollapsed1 }"
          id="sidebar-link-collapse1-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('operations') }}
              </strong>
            </div>

            <router-link
              v-if="$store.getters['enums/user_info'].branch"
              id="sidebar-link-departure-arrival"
              to="/departure-arrival"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'departure-arrival',
                },
              ]"
            >
              {{ $t('departure-arrival') }}
            </router-link>

            <router-link
              v-if="false && !$store.getters['enums/is_not_permitted']('operationsVehicleTab')"
              id="sidebar-link-vehicle-operations"
              to="/vehicle-operations"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'vehicle-operations',
                },
              ]"
            >
              {{ $t('vehicles') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('operationsContractedJourneyTab')"
              id="sidebar-link-manage-trips"
              to="/manage-trips"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'manage-trips',
                },
              ]"
            >
              {{ $t('manage-trips') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('operationsCheckAvailabilityTab')"
              id="sidebar-link-check-availability"
              to="/check-availability"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'check-availability',
                },
              ]"
            >
              {{ $t('check-availability') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('reportedIssues')"
              id="sidebar-link-reported-issues"
              to="/reported-issues"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'reported-issues',
                },
              ]"
            >
              {{ $t('reported-issues') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewReportedTankIssuesTab')"
              id="sidebar-link-reported-tank-issues"
              to="/reported-tank-issues"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'reported-tank-issues',
                },
              ]"
            >
              {{ $t('reported-tank-issues') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('transactionLogTab')"
              id="sidebar-link-transaction-log"
              to="/transaction-log"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'transaction-log',
                },
              ]"
            >
              {{ $t('transaction-log') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('transactionLogTab')"
              id="sidebar-link-external-log"
              to="/external-log"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'external-log',
                },
              ]"
            >
              {{ $t('external-log') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewDriverAllowance')"
              id="sidebar-link-driver-allowance"
              to="/driver-allowance"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'driver-allowance',
                },
              ]"
            >
              {{ $t('driver-allowance') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <!-- ── Finances sub-menu ── -->
        <!-- Added: certificates_of_completion router-link guarded by financeCertificateOfCompletion -->
        <!-- Added: certificates_of_completion to checkCollapseSidebar2 (in <script>) -->
        <div
          v-if="isCollapsed2"
          :class="{ collapsed: isCollapsed2 }"
          id="sidebar-link-collapse2-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('finances') }}
              </strong>
            </div>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('receiptVoucherTab')"
              id="sidebar-link-finances"
              to="/finances"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'finances',
                },
              ]"
            >
              {{ $t('receipt-vouchers') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('financeAccountsTab')"
              id="sidebar-link-account-listing"
              to="/account-listing"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'account-listing',
                },
              ]"
            >
              {{ $t('accounts') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('financeProformaInvoiceTab')"
              id="sidebar-link-proforma-invoice-listing"
              to="/proforma-invoice-listing"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'proforma-invoice-listing',
                },
              ]"
            >
              {{ $t('proforma-invoices') }}
            </router-link>

            <router-link
              id="sidebar-link-jv-listing"
              v-if="!$store.getters['enums/is_not_permitted']('financeCertificateOfCompletion')"
              to="/certificates_of_completion"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'certificates_of_completion',
                },
              ]"
            >
              {{ $t('Certificate_of_Completion') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('financeJVTab')"
              id="sidebar-link-jv-listing"
              to="/jv-listing"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'jv-listing',
                },
              ]"
            >
              {{ $t('journal-vouchers') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewTransaction')"
              id="sidebar-link-post-transactions-listing"
              to="/post-transactions"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'post-transactions',
                },
              ]"
            >
              {{ $t('post-transactions') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewPaymentVoucher')"
              id="sidebar-link-payment-voucher-listing"
              to="/payment-voucher"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'payment-voucher',
                },
              ]"
            >
              {{ $t('payment-voucher') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewFinancialClaim')"
              id="sidebar-link-financial-claim-listing"
              to="/financial-claim"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'financial-claim',
                },
              ]"
            >
              {{ $t('financial-claim') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('taxTypeTab')"
              id="sidebar-link-tax-types-listing"
              to="/tax-types"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'tax-types',
                },
              ]"
            >
              {{ $t('tax-types') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('masterAccountsTab')"
              id="sidebar-link-master-accounts"
              to="/master-accounts"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'master-accounts',
                },
              ]"
            >
              {{ $t('master-accounts') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed3"
          :class="{ collapsed: isCollapsed3 }"
          id="sidebar-link-collapse2-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('resources') }}
              </strong>
            </div>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('driverTab')"
              id="sidebar-link-drivers"
              to="/drivers"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'drivers',
                },
              ]"
            >
              {{ $t('drivers') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('vehicleTab')"
              id="sidebar-link-vehicles"
              to="/vehicles"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'vehicles',
                },
              ]"
            >
              {{ $t('vehicles') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed4"
          :class="{ collapsed: isCollapsed4 }"
          id="sidebar-link-collapse2-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('partners') }}
              </strong>
            </div>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('supplierTab')"
              id="sidebar-link-suppliers"
              to="/suppliers"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'suppliers',
                },
              ]"
            >
              {{ $t('suppliers') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed5"
          :class="{ collapsed: isCollapsed5 }"
          id="sidebar-link-collapse2-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('requests') }}
              </strong>
            </div>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewTemporaryRequest')"
              id="sidebar-link-resource-requests"
              to="/resource-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'resource-requests',
                },
              ]"
            >
              {{ $t('resource-requests') }}
            </router-link>
            <router-link
              v-if="
                !$store.getters['enums/is_not_permitted']('viewTemporaryResourcesRequest') ||
                !$store.getters['enums/is_not_permitted']('viewReservationRequest')
              "
              id="sidebar-link-my-requests"
              to="/my-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'my-requests',
                },
              ]"
            >
              {{ $t('my-requests') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('replaceRequestTab')"
              id="sidebar-link-replace-requests-list"
              to="/replace-requests-list"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'replace-requests-list',
                },
              ]"
            >
              {{ $t('replace-requests') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('operationsApprovalRequestTab')"
              id="sidebar-link-approval-requests"
              to="/approval-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'approval-requests',
                },
              ]"
            >
              {{ $t('approval-requests') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('timeOffRequest')"
              id="sidebar-link-time-off-requests"
              to="/time-off-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'time-off-requests',
                },
              ]"
            >
              {{ $t('time-off-requests') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewReservationRequest')"
              id="sidebar-link-reservations-requests"
              to="/reservations-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'reservations-requests',
                },
              ]"
            >
              {{ $t('reservations-requests') }}
            </router-link>
            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('viewDriverAllowance')"
              id="sidebar-link-allowance-requests"
              to="/allowance-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active':
                    $route.name == 'allowance-requests',
                },
              ]"
            >
              {{ $t('allowance-requests') }}
            </router-link>
            <router-link
              v-if="
                !$store.getters['enums/is_not_permitted']('manageAllTasks') ||
                !$store.getters['enums/is_not_permitted']('viewMyTasks')
              "
              id="sidebar-link-workflow-requests"
              to="/workflow-requests"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'workflow-requests',
                },
              ]"
            >
              {{ $t('workflow-requests') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed6"
          :class="{ collapsed: isCollapsed6 }"
          id="sidebar-link-collapse2-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('sales') }}
              </strong>
            </div>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('operationsReservationTab')"
              id="sidebar-link-operations"
              to="/operations/list"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'operations',
                },
              ]"
            >
              {{ $t('reservations') }}
            </router-link>

            <router-link
              v-if="!$store.getters['enums/is_not_permitted']('clientTab')"
              id="sidebar-link-clients"
              to="/clients"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'clients',
                },
              ]"
            >
              {{ $t('clients') }}
            </router-link>

            <router-link
              id="sidebar-link-blanket-orders"
              v-if="!$store.getters['enums/is_not_permitted']('listBlanketOrder')"
              to="/blanket-orders"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'blanket-orders',
                },
              ]"
            >
              {{ $t('blanket-orders') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed7"
          :class="{ collapsed: isCollapsed7 }"
          id="sidebar-link-collapse7-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('my-profile') }}
              </strong>
            </div>
            <router-link
              id="sidebar-link-my-profile-sub"
              to="/my-profile"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'my-profile',
                },
              ]"
            >
              {{ $t('my-profile') }}
            </router-link>
            <router-link
              id="sidebar-link-change-password"
              to="/change-password"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'change-password',
                },
              ]"
            >
              {{ $t('change-password') }}
            </router-link>
          </div>
        </div>
      </transition>
      <transition name="collapse-transition">
        <div
          v-if="isCollapsed8"
          :class="{ collapsed: isCollapsed8 }"
          id="sidebar-link-collapse8-transition"
          class="sidebar-content mx-3 d-flex"
        >
          <div>
            <div class="mt-4 mb-3">
              <strong class="sub-title">
                {{ $t('contracts') }}
              </strong>
            </div>
            <router-link
              id="sidebar-link-contracts"
              to="/contracts"
              :class="[
                'nav-link sub-nav-link my-2',
                {
                  'router-link-exact-active router-link-active': $route.name == 'contracts',
                },
              ]"
            >
              {{ $t('contracts') }}
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import JwtUtilService from '@/services/jwt.util.service'

export default {
  name: 'TheSideBar',
  props: ['notMobile', 'showSubMenu'],
  data() {
    return {
      isCollapsed1: false,
      isCollapsed2: false,
      isCollapsed3: false,
      isCollapsed4: false,
      isCollapsed5: false,
      isCollapsed6: false,
      isCollapsed7: false,
      isCollapsed8: false,
    }
  },
  computed: {
    getChangePasswordToken() {
      return this.$store.getters['enums/change_password_token']
    },
  },
  methods: {
    toggleSubMenu() {
      this.$emit('subMenuClosed')
    },
    checkCollapseSidebar1() {
      if (
        this.$route.name == 'departure-arrival' ||
        this.$route.name == 'vehicle-operations' ||
        this.$route.name == 'manage-trips' ||
        this.$route.name == 'transaction-log' ||
        this.$route.name == 'external-log' ||
        this.$route.name == 'driver-allowance' ||
        this.$route.name == 'check-availability' ||
        this.$route.name == 'long-terms' ||
        this.$route.name == 'reported-issues' ||
        this.$route.name == 'reported-tank-issues'
      )
        this.isCollapsed1 = true
      else this.isCollapsed1 = false
    },
    checkCollapseSidebar2() {
      if (
        this.$route.name == 'finances' ||
        this.$route.name == 'account-listing' ||
        this.$route.name == 'proforma-invoice-listing' ||
        this.$route.name == 'certificates_of_completion' ||
        this.$route.name == 'jv-listing' ||
        this.$route.name == 'tax-types' ||
        this.$route.name == 'post-transactions' ||
        this.$route.name == 'payment-voucher' ||
        this.$route.name == 'statement' ||
        this.$route.name == 'master-accounts' ||
        this.$route.name == 'financial-claim'
      )
        this.isCollapsed2 = true
      else this.isCollapsed2 = false
    },
    checkCollapseSidebar3() {
      if (this.$route.name == 'drivers' || this.$route.name == 'vehicles') this.isCollapsed3 = true
      else this.isCollapsed3 = false
    },
    checkCollapseSidebar4() {
      if (this.$route.name == 'suppliers') this.isCollapsed4 = true
      else this.isCollapsed4 = false
    },
    checkCollapseSidebar5() {
      if (
        this.$route.name == 'resource-requests' ||
        this.$route.name == 'my-requests' ||
        this.$route.name == 'replace-requests-list' ||
        this.$route.name == 'approval-requests' ||
        this.$route.name == 'time-off-requests' ||
        this.$route.name == 'reservations-requests' ||
        this.$route.name == 'allowance-requests' ||
        this.$route.name == 'workflow-requests'
      )
        this.isCollapsed5 = true
      else this.isCollapsed5 = false
    },
    checkCollapseSidebar6() {
      if (
        this.$route.name == 'clients' ||
        this.$route.name == 'operations' ||
        this.$route.name == 'blanket-orders'
      )
        this.isCollapsed6 = true
      else this.isCollapsed6 = false
    },
    checkCollapseSidebar7() {
      if (this.$route.name == 'change-password' || this.$route.name == 'my-profile')
        this.isCollapsed7 = true
      else this.isCollapsed7 = false
    },
    checkCollapseSidebar8() {
      if (this.$route.name == 'contracts') this.isCollapsed8 = true
      else this.isCollapsed8 = false
    },
    logout() {
      const keycloakURL = this.$config.keyCloakURL
      this.$store.dispatch('auth/logout').then(() => {
        window.open(
          `${keycloakURL}/logout?post_logout_redirect_uri=${
            window.location.origin
          }/auth/login&id_token_hint=${JwtUtilService.getIdToken()}`,
          '_self'
        )
      })
    },
    emitSubMenuShow() {
      this.$emit('showSubMenuFunction')
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/suppliers.json'),
      ar: require('@/services/i18n/locales/ar/suppliers.json'),
    },
  },
  watch: {
    $route() {
      this.checkCollapseSidebar1()
      this.checkCollapseSidebar2()
      this.checkCollapseSidebar3()
      this.checkCollapseSidebar4()
      this.checkCollapseSidebar5()
      this.checkCollapseSidebar6()
      this.checkCollapseSidebar7()
      this.checkCollapseSidebar8()
    },
    getChangePasswordToken(val) {
      if (val) {
        const accessToken = localStorage.getItem('access_token')
        if (val !== accessToken) {
          this.logout()
        }
      }
      this.$store.dispatch('enums/GET_CHANGE_PASSWORD_TOKEN', null)
    },
  },
  mounted() {
    this.checkCollapseSidebar1()
    this.checkCollapseSidebar2()
    this.checkCollapseSidebar3()
    this.checkCollapseSidebar4()
    this.checkCollapseSidebar5()
    this.checkCollapseSidebar6()
    this.checkCollapseSidebar7()
    this.checkCollapseSidebar8()
  },
}
</script>

<style lang="scss" scoped>
.toggle-sub-menu {
  inset-inline-end: 0;
}

.header-container {
  border-inline-end: 1px solid var(--color-149);
  z-index: 6666;

  &:hover {
    .toggle-sub-menu img {
      opacity: 1 !important;
    }
  }
}

.router-link-exact-active,
.router-link-active {
  background-color: var(--color-151) !important;
  border-radius: 0.25rem;
  color: var(--color-116) !important;
}

.nav-sss-logo {
  border-bottom: 1px solid var(--color-64);
  padding-bottom: 5px;
}

.nav-link {
  padding: 10px;
}

.nav-link:hover {
  background-color: #eef9ff83;
  border-radius: 0.25rem;
  color: var(--color-116) !important;
}

.sub-nav-link {
  padding: 0.5rem;
}

::-webkit-scrollbar {
  display: none;
}

.sub-title {
  color: var(--color-01);
}

.main-links {
  background-color: var(--color-150);
}

.sub-links {
  background-color: var(--color-116);
  min-width: 200px;
  flex: 1;
  border-inline-end: 1px solid var(--color-101);
}
</style>

<style>
.bs-tooltip-left {
  left: 50px !important;
}

.bs-tooltip-right {
  left: -50px !important;
}

.tooltip-inner {
  background-color: var(--color-01) !important;
  color: var(--color-13) !important;
  box-shadow: 0px 2px 6px 0px var(--color-42) !important;
}
</style>
